import React, { useState, useEffect } from "react";
import { API_SERVER_URL, USER_NAME } from "../../constant";
import { sendToBackend } from "../../utils/utilities";

import { showSuccessAlert, showErrorAlert, showWarningAlert, showInfoAlert, showConfirmDialog } from '../../utils/sweetAlertConfig';
import '../../styles/sweetAlert.css';

import { getUserCurrentPlan } from "../../dbApiFunctions";
import { planFeatures, monthlyPrices, yearlyPrices } from "../../constant";


const SubscriptionPlans = ({ readOnly }) => {
  const [isMonthly, setIsMonthly] = useState(true);
  const [creditsAvailable, setCreditsAvailable] = useState(0);
  const [currentPlan, setCurrentPlan] = useState("Free Plan");

  useEffect(() => {
    const email = sessionStorage.getItem('email');
    const fetchCurrentPlan = async () => {
      const result = await getUserCurrentPlan(email);
      if (result.status) {
        setCurrentPlan(result.currentPlan);
      }
    };
    fetchCurrentPlan();
  }, []);

  const startStripeSession = async (planName, price, isMonthly) => {
    const email = sessionStorage.getItem('email');
    const formData = {
      planName: planName,
      price: price,
      isMonthly: isMonthly,
      userName: USER_NAME,
      email: email
    };

    const response = await sendToBackend('create-checkout-session', formData, 0, setCreditsAvailable);
    // console.log("Stripe session response:", response);

    if (response && response.url) {
      // Redirect to Stripe checkout
      window.location.href = response.url;
    } else {
      console.error("Stripe session creation failed:", response);
      showErrorAlert('Failed to initiate payment session. Please try again.', 'Payment Session Failed', 'If the problem persists, please contact support');
    }
  };

  const handleEnterpriseContact = () => {
    showInfoAlert(
      'Please email us at    ____support@shutterlabs.app_____     for custom enterprise solutions and pricing.',
      'Enterprise Plan',
      'Please email us at support@shutterlabs.app for custom enterprise solutions and pricing.'
    );
  };

  return (
    <div className="bg-white py-8 px-4 md:px-6 lg:px-8">
      <div className="mx-auto">
        <div className="text-center mb-8">
          <div className="text-white py-2 px-4 rounded-lg mb-6 inline-block" style={{ background: 'linear-gradient(to right, #4c1df8, #6f3fff)' }}>
            <span className="text-lg font-bold">🎉 Special Offer: 50% OFF on All Plans! 🎉</span>
          </div>
          <h1 className="text-3xl font-extrabold text-black mb-3">
            Choose Your Perfect Plan
          </h1>
          <p className="text-base text-gray-600 max-w-2xl mx-auto mb-6">
            Select the subscription that best fits your needs and start creating amazing content today.
          </p>
{/* 
          <div className="flex justify-center mb-8">
            <div className="bg-white/50 backdrop-blur-sm p-1 rounded-full shadow-lg border border-gray-100">
              <button
                onClick={() => setIsMonthly(true)}
                className={`px-5 py-1.5 rounded-full transition-all duration-300 text-sm ${isMonthly
                  ? 'text-white shadow-lg'
                  : 'text-gray-600 hover:bg-gray-100'
                  }`}
                style={isMonthly ? { background: 'linear-gradient(to right, #4c1df8, #6f3fff)' } : {}}
              >
                Monthly
              </button>
              <button
                onClick={() => setIsMonthly(false)}
                className={`px-5 py-1.5 rounded-full transition-all duration-300 text-sm ${!isMonthly
                  ? 'text-white shadow-lg'
                  : 'text-gray-600 hover:bg-gray-100'
                  }`}
                style={!isMonthly ? { background: 'linear-gradient(to right, #4c1df8, #6f3fff)' } : {}}
              >
                Yearly <span className="text-green-500 ml-1 font-semibold">20% off</span>
              </button>
            </div>
          </div> */}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {["Free Plan", "Basic Plan", "Standard Plan", "Premium Plan", "Enterprise Plan"].map((plan, index) => {
            const originalPrice = isMonthly ? monthlyPrices[index] : yearlyPrices[index];
            const isEnterprise = plan === "Enterprise Plan";
            const isFree = index === 0;
            
            let discountedPrice, buttonText, isPopular;
            
            if (isEnterprise) {
              discountedPrice = "Custom";
              buttonText = "Contact Us";
              isPopular = false;
            } else {
              const numericPrice = parseFloat(originalPrice.replace('$', ''));
              discountedPrice = isFree ? originalPrice : `$${(numericPrice * 0.5).toFixed(2)}`;
              buttonText = plan === currentPlan ? "Current Plan" : "Choose Plan";
              isPopular = index === 2;
            }

              return (
                <div
                  key={index}
                  className={`relative bg-white rounded-lg shadow overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-lg ${isPopular ? 'border-2' : 'border border-gray-100'}`}
                  style={isPopular ? { borderColor: '#4c1df8' } : {}}
                >
                  {isPopular && (
                    <div className="absolute top-0 right-0 text-white text-xs font-semibold px-2 py-0.5 rounded-bl-lg" style={{ background: 'linear-gradient(to right, #4c1df8, #6f3fff)' }}>
                      Most Popular
                    </div>
                  )}
                  <div className="p-4">
                    <h2 className="text-lg font-bold text-black mb-1">{plan}</h2>
                    <div className="flex items-baseline mb-3">
                      {index !== 0 && (
                        <span className="text-lg line-through text-gray-400 mr-2">{originalPrice}</span>
                      )}
                      <span className="text-3xl font-extrabold text-black">
                        {discountedPrice}
                      </span>
                      <span className="text-gray-500 text-sm ml-1">/month</span>
                      {/* <div className="text-xs text-gray-400 ml-1">
                        {isMonthly ? 'billed monthly' : 'billed yearly'}
                      </div> */}
                    </div>
                    <ul className="space-y-2 mb-4 text-left">
                      {planFeatures[plan].map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-start text-black text-xs text-left">
                          <svg className="w-3.5 h-3.5 text-green-500 mr-1.5 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                          </svg>
                          <span className="text-left">{feature}</span>
                        </li>
                      ))}
                    </ul>
                    {!readOnly && (
                      <button
                        onClick={() => {
                          if (index !== 0 && plan !== currentPlan) {
                            const planName = plan;
                            const planPrice = discountedPrice.replace('$', '');
                            startStripeSession(planName, planPrice, isMonthly);
                          }
                        }}
                        className={`w-full py-2 px-3 rounded font-semibold transition-all duration-300 text-xs ${index === 0 || plan === currentPlan
                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                            : 'text-white shadow hover:shadow-lg'
                          }`}
                        style={index !== 0 && plan !== currentPlan ? { background: 'linear-gradient(to right, #4c1df8, #6f3fff)' } : {}}
                        disabled={index === 0 || plan === currentPlan}
                      >
                        {buttonText}
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlans;
